import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { notifyAndLogError } from 'src/UI/common/ui-helpers';

export function useRenameConversation() {
  const queryClient = useQueryClient();

  const {
    mutate,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<{ data: unknown }, Error, { id: string; title: string }>({
    mutationFn: ({ id, title }) => api.patch(`conversations/${id}`, { title }),
    onError: renameError =>
      notifyAndLogError(
        'Could not rename chat',
        'The chat could not be renamed. Please try again.',
        renameError,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['conversations'] });
    },
  });

  const renameConversation = (id: string, title: string) => mutate({ id, title });

  return { renameConversation, error, isLoading, reset };
}
